<template>
  <div id="skills" class="page-container">
    <div class="page-content">
      <div class="flex-row-center mt-16">
        <img src="../assets/images/navbar/ic_skills.webp" class="icon-pages" />
        <span class="page-title">{{ $t("page.skills") }}</span>
        <span class="page-des page-des-line">{{
          $t("page.skills_description")
        }}</span>
      </div>

      <el-tabs
        class="style-bar"
        v-model="activeName"
      >
        <el-tab-pane :name="anchor.proficiencies">
          <span slot="label" class="title-bar">Proficiencies</span>
          <proficiencies @tabChanged="onChangedTab" v-if="activeName == anchor.proficiencies"></proficiencies>
        </el-tab-pane>
        <el-tab-pane :name="anchor['learning-journeys']">
          <span slot="label" class="title-bar">Learning Journeys</span>
          <learning-journeys v-if="activeName == anchor['learning-journeys']"></learning-journeys>
        </el-tab-pane>
        <el-tab-pane :name="anchor['power-skills']">
          <span slot="label" class="title-bar">Power Skills</span>
          <power-skills v-if="activeName == anchor['power-skills']"></power-skills>
        </el-tab-pane>
      </el-tabs>
      
    </div>
  </div>
</template>

<script>
export default {
  name: "skills",
  components: {
    proficiencies: require("./skills/proficiencies.vue").default,
    powerSkills: require("./skills/power-skills").default,
    learningJourneys: require("./skills/learning-journeys").default,
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
  },
  watch: {
    activeName() {
      if (this.activeName != "") {
        const tab = this.activeName || "";
        const paramsTab = this.$router.currentRoute.params.tab;
        if (paramsTab != tab) {
          this.$router.push({ name: "skills", params: { tab } });
        }
      }
    }
  },
  data() {
    return {
      activeName: "learning-journeys",
      anchor: {
        proficiencies: "proficiencies",
        'power-skills': "power-skills",
        'learning-journeys': "learning-journeys",
      },
      renderComponent: true,
    };
  },
  mounted() {
    const params = this.$router.currentRoute.params.tab;
    if (params && this.anchor[params]) {
      this.activeName = params;
    } else {
      this.$router.push({ name: 'skills', params: { tab: "learning-journeys" } })
    }
  
  },
  methods: {
    onChangedTab(value) {
      console.log('onChangedTab',value)
      this.activeName = value.tab;
    },
   
  },
};
</script>
<style scoped></style>
<style>
#skills .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 200px;
  text-align: center;
}

#skills .el-tabs__header {
  margin: 0;
}
</style>
